import { Typography, theme } from 'antd';
import { CSSProperties } from 'react';
import { useTranslation } from 'react-i18next';
import { status, statusi18nKeyMap } from '../model/types';
import { tagBackgroundColors } from '../styles/theme';

interface MiniTagProps {
    height?: CSSProperties['lineHeight'];
    status?: status;
    mini?: boolean;
    centered?: boolean;
}

export default function MiniTag({ status = 'New', mini }: MiniTagProps) {
    const {
        token: { borderRadiusSM, colorTextLightSolid, fontSizeSM, fontWeightStrong, paddingXS, paddingXXS }
    } = theme.useToken();
    const { t } = useTranslation('common');

    const style: CSSProperties = {
        backgroundColor: tagBackgroundColors[status],
        borderRadius: borderRadiusSM,
        color: colorTextLightSolid,
        fontSize: mini ? fontSizeSM : fontSizeSM / 1.2,
        fontWeight: fontWeightStrong,
        padding: mini ? `${paddingXXS / 2}px ${paddingXS / 2}px` : `${paddingXS / 2}px ${paddingXS}px`
    };

    const text = mini
        ? status === 'On Hold'
            ? t('H')
            : t(statusi18nKeyMap[status]).charAt(0)
        : t(statusi18nKeyMap[status]);

    return <Typography.Text style={style}>{text}</Typography.Text>;
}
